import { Tag } from "antd";
import STATUS from "../consts/status";

export const orderStatusGhtk = (status, text) => {
  let color = "#000";
  switch (status) {
    case -1:
      color = "red";
      text = "Hủy đơn hàng"
      break;
    case 1:
      color = "orange";
      break;
    case 2:
      color = "lime";
      break;
    case 3:
      color = "blue";
      break;
    case 4:
      color = "orange";
      break;
    case 5:
      color = "#87d068";
      break;
    case 6:
      color = "cyan";
      break;
    default:
      color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
      break;
  }
  return (
    <Tag className="my-tag" color={color}>
      {text}
    </Tag>
  );
};

export const renderOrderStatus = (params) => {
  switch (params) {
    case STATUS.ORDER_PENDING:
      return <Tag color="#F78C52">CHƯA XÁC NHẬN</Tag>;
    case STATUS.ORDER_CANCELED:
      return <Tag color="#DD0E0E">ĐÃ HỦY</Tag>;
    case STATUS.ORDER_CONFIRM:
      return <Tag color="#87d068">ĐÃ XÁC NHẬN</Tag>;
    case STATUS.ORDER_SUCCESS:
      return <Tag color="green">THÀNH CÔNG</Tag>;
    case STATUS.ORDER_READY:
      return <Tag color="#f50">CHỜ LẤY HÀNG </Tag>;
    case STATUS.ORDER_PICKUP:
      return <Tag color="#2db7f5">ĐÃ LẤY HÀNG</Tag>;
    case STATUS.ORDER_SHIPPING:
      return <Tag color="purple">ĐANG GIAO HÀNG </Tag>;
    case STATUS.ORDER_DELIVERED:
      return <Tag color="rgb(252 52 255)">ĐÃ GIAO HÀNG </Tag>;
      case STATUS.ORDER_REFUNDED:
        return <Tag color="#443B3B">ĐÃ HOÀN TIỀN </Tag>;
    default:
      return <Tag color="red">LỖI</Tag>;
  }
};

export const renderPaymentMethod = (params) => {
  const color = params === "cod" ? "#8C8C8C" : "purple";
  return <Tag color={color}>{params ? params.toUpperCase() : params}</Tag>;
};

export const renderPaymentStatus = (params) => {
  switch (params) {
    case STATUS.PAYMENT_PENDING:
      return <Tag color="orange">CHỜ THANH TOÁN</Tag>;
    case STATUS.PAYMENT_NOT_PAID:
      return <Tag color="red">CHƯA THANH TOÁN</Tag>;
    case STATUS.PAYMENT_PAID:
      return <Tag color="green">ĐÃ THANH TOÁN </Tag>;
    default:
      return <Tag color="red">LỖI</Tag>;
  }
};

export const renderShippingMethod = (params) => {
  const color = params === "vnfarm" ? "#8C8C8C" : "green";
  return <Tag color={color}>{params ? params.toUpperCase() : params}</Tag>;
};

export const renderShippingStatus = (params) => {
  switch (params) {
    case STATUS.SHIPPING_PENDING:
      return <Tag color="orange">CHƯA XÁC NHẬN</Tag>;
    case STATUS.SHIPPING_READY:
      return <Tag color="magenta">CHƯA LẤY HÀNG </Tag>;
    case STATUS.SHIPPING_PICKUP:
      return <Tag color="blue">ĐÃ LẤY HÀNG</Tag>;
    case STATUS.SHIPPING_SHIPPING:
      return <Tag color="purple">ĐANG GIAO HÀNG </Tag>;
    case STATUS.SHIPPING_DELIVERED:
      return <Tag color="rgb(252 52 255)">ĐÃ GIAO HÀNG </Tag>;
    default:
      return <Tag color="red">LỖI</Tag>;
  }
};

export const renderShippingStatusV2 = (params) => {
  switch (params) {
    case STATUS.ORDER_PENDING:
      return (
        <Tag className="my-tag" color="#F78C52">
          CHƯA XÁC NHẬN
        </Tag>
      );
    case STATUS.ORDER_CANCELED:
      return (
        <Tag className="my-tag" color="#DD0E0E">
          ĐÃ HỦY
        </Tag>
      );
    case STATUS.ORDER_CONFIRM:
      return (
        <Tag className="my-tag" color="#87d068">
          ĐÃ XÁC NHẬN
        </Tag>
      );
    case STATUS.ORDER_SUCCESS:
      return (
        <Tag className="my-tag" color="green">
          THÀNH CÔNG
        </Tag>
      );
    case STATUS.ORDER_READY:
      return (
        <Tag className="my-tag" color="#f50">
          CHỜ LẤY HÀNG{" "}
        </Tag>
      );
    case STATUS.ORDER_PICKUP:
      return (
        <Tag className="my-tag" color="#2db7f5">
          ĐÃ LẤY HÀNG
        </Tag>
      );
    case STATUS.ORDER_SHIPPING:
      return (
        <Tag className="my-tag" color="purple">
          ĐANG GIAO HÀNG{" "}
        </Tag>
      );
    case STATUS.ORDER_DELIVERED:
      return (
        <Tag className="my-tag" color="rgb(252 52 255)">
          ĐÃ GIAO HÀNG{" "}
        </Tag>
      );

      case STATUS.ORDER_REFUNDED:
        return (
          <Tag className="my-tag" color="#443B3B">
            ĐÃ HOÀN TIỀN{" "}
          </Tag>
        );

    // case STATUS.SHIPPING_PENDING:
    //   return (
    //     <Tag className="my-tag" color="#cd201f">
    //       CHƯA XÁC NHẬN
    //     </Tag>
    //   );
    // case STATUS.SHIPPING_READY:
    //   return (
    //     <Tag className="my-tag" color="#f50">
    //       CHƯA LẤY HÀNG{" "}
    //     </Tag>
    //   );
    // case STATUS.SHIPPING_PICKUP:
    //   return (
    //     <Tag className="my-tag" color="#2db7f5">
    //       ĐÃ LẤY HÀNG
    //     </Tag>
    //   );
    // case STATUS.SHIPPING_SHIPPING:
    //   return (
    //     <Tag className="my-tag" color="purple">
    //       ĐANG GIAO HÀNG{" "}
    //     </Tag>
    //   );
    // case STATUS.SHIPPING_DELIVERED:
    //   return (
    //     <Tag className="my-tag" color="#87d068">
    //       ĐÃ GIAO HÀNG{" "}
    //     </Tag>
    //   );
    default:
      return (
        <Tag className="my-tag" color="red">
          LỖI
        </Tag>
      );
  }
};
